import React from 'react';
import { Table } from "reactstrap";
import RedirectToLive from '../containers/RedirectToLive';

const PointsRaceResults = (props) => {
  const {
    EventName,
    pointsRaceResultsList,
    sprintList,
    ExecuteUpdate,
  } = props;

  const contentPointsResults = pointsRaceResultsList.map((pointsRace, i) =>
    <tr key={i}>
      <td>{pointsRace.Rank}</td>
      <td>{pointsRace.Bib}</td>
      <td>{pointsRace.Name}</td>
      {/* <td>{pointsRace.Nat}</td> */}
      <td>
        <img
          src={process.env.PUBLIC_URL + '/Flags/' + pointsRace.Nat + '.bmp'}
          height="25"
          width="60"
          alt={pointsRace.Nat}
        />
      </td>
      <td>{pointsRace.Laps}</td>
      <td>{pointsRace.Points}</td>
    </tr>
  );

  const PointsResult = () => {
    return (<div>
      <h2>{EventName} Results </h2>
      <br />
      <br />
      <Table>
        <thead>
          <tr>
            <th>Rank</th>
            <th>Bib</th>
            <th>Name</th>
            <th>Nation</th>
            <th>Laps</th>
            <th>Points</th>
          </tr>
        </thead>
        <tbody>
          {contentPointsResults}
        </tbody>
      </Table>
    </div>);
  }

  const contentSprints = sprintList.map((item, i) =>
    <tr key={i}>
      <td>{item.Name}</td>

      <td>{item.p1Bib}</td>
      <td>{item.p1Name}</td>
      <td>
        {item.p1Nat && <img
          src={process.env.PUBLIC_URL + '/Flags/' + item.p1Nat + '.bmp'}
          height="25"
          width="60"
          alt={item.p1Nat}
        />}
      </td>
      <td>{item.p1Points !== 0 ? item.p1Points : ''}</td>

      <td>{item.p2Bib}</td>
      <td>{item.p2Name}</td>
      <td>
        {item.p2Nat && <img
          src={process.env.PUBLIC_URL + '/Flags/' + item.p2Nat + '.bmp'}
          height="25"
          width="60"
          alt={item.p2Nat}
        />}
      </td>
      <td>{item.p2Points !== 0 ? item.p2Points : ''}</td>

      <td>{item.p3Bib}</td>
      <td>{item.p3Name}</td>
      <td>
        {item.p3Nat && <img
          src={process.env.PUBLIC_URL + '/Flags/' + item.p3Nat + '.bmp'}
          height="25"
          width="60"
          alt={item.p3Nat}
        />}
      </td>
      <td>{item.p3Points !== 0 ? item.p3Points : ''}</td>

      <td>{item.p4Bib}</td>
      <td>{item.p4Name}</td>
      <td>
        {item.p4Nat && <img
          src={process.env.PUBLIC_URL + '/Flags/' + item.p4Nat + '.bmp'}
          height="25"
          width="60"
          alt={item.p4Nat}
        />}
      </td>
      <td>{item.p4Points !== 0 ? item.p4Points : ''}</td>
    </tr>
  );

  const SprintTable = () => {
    return (
      <div>
        <br />
        <br />
        <Table>
          <thead>
            <tr>
              <th>Sprint</th>

              <th>Bib</th>
              <th>1 Place</th>
              <th>Flag</th>
              <th>Points</th>

              <th>Bib</th>
              <th>2 Place</th>
              <th>Flag</th>
              <th>Points</th>

              <th>Bib</th>
              <th>3 Place</th>
              <th>Flag</th>
              <th>Points</th>

              <th>Bib</th>
              <th>4 Place</th>
              <th>Flag</th>
              <th>Points</th>
            </tr>
          </thead>
          <tbody>
            {contentSprints}
          </tbody>
        </Table>
        <br />
        <br />
        <br />
      </div>
    );
  }

  return (
    <div className="container">
      <RedirectToLive Update={ExecuteUpdate} />
      <PointsResult />
      {sprintList.length > 0 && <SprintTable />}
    </div>
  );
};

export default PointsRaceResults;  